module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.ac3f799d.ttf";